/* src/app/account/card-style.scss */
.card-container {
  gap: 30px;
}
.card-title {
  padding: 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  background-color: #f6f6f6;
  border-radius: 20px;
}
.card-title ion-icon {
  width: 35px;
  height: 35px;
}
.card-title span.header {
  font-family: Raleway;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 39px;
  letter-spacing: -0.64px;
}
.card-title span.subheader {
  color: #d59b00;
  font-family: "Barlow Semi Condensed";
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 20px;
  font-style: normal;
  margin: 0;
  min-height: 0;
  font-weight: 500;
  line-height: normal;
  padding: 14px 18px;
  border-radius: 15px;
  transition:
    background 0.08s,
    color 0.08s,
    box-shadow 0.08s;
  cursor: pointer;
}
button ion-icon {
  margin-right: 10px;
  font-size: 18px;
}
button.dark {
  background: black;
  color: white;
}
button.dark:hover {
  background: #43c0f6;
}
button.outline-dark {
  background: white;
  color: black;
  box-shadow: inset 0px 0px 0px 2px black;
}
button.outline-dark:hover {
  color: #ff007f;
  box-shadow: inset 0px 0px 0px 2px #ff007f !important;
}
button.blue {
  background: #43c0f6;
  color: white;
}
button.blue:hover {
  background: #0c8ce9;
}
button.gray {
  background: #f6f6f6;
  color: black;
}
button.gray:hover {
  background: #cbcbcb;
}
button:active {
  opacity: 0.7;
}
button:disabled {
  opacity: 0.5;
  cursor: default;
  pointer-events: none;
}
@media (max-width: 850px) {
  .card-title ion-icon {
    width: 28px;
    height: 28px;
  }
  .card-title span.header {
    font-size: 24px;
    letter-spacing: -0.48px;
  }
  .card-title span.subheader {
    font-size: 14px;
  }
  button {
    font-size: 18px;
    padding: 12px 16px;
  }
  .accountAvatar {
    height: 60px;
    width: 60px;
  }
  .accountAvatar ion-icon {
    width: 24px;
    height: 24px;
    top: -22px;
    left: 34px;
  }
}
@media (max-width: 470px) {
  .card-title {
    gap: 10px;
  }
  .card-title ion-icon {
    width: 28px;
    height: 28px;
  }
  .card-title span.header {
    font-size: 20px;
    letter-spacing: -0.4px;
  }
  button {
    justify-content: center;
  }
}
/*# sourceMappingURL=card-style-BVHX5OXF.css.map */
